import { modifier } from 'ember-modifier';

export default modifier((element, [ref]) => {
  if (ref) {
    ref(element);

    return () => {
      ref(null);
    };
  }
}, { eager: false });
